<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <!-- <router-view/> -->
   <!--  <nav>
      <router-link to="">Portada </router-link>
    </nav> -->
    <router-view/>
   <!--  <cabecera></cabecera>
    <menuLateral></menuLateral>
    <cesiumViewer></cesiumViewer>
    <pie></pie> -->
  </div>
</template>

<script>

import cabecera from './components/cabecera.vue'
import cesiumViewer from './components/cesiumViewer.vue'
import menuLateral from './components/menuLateral.vue'
import pie from './components/pie.vue'


export default {
  name: 'App',
  components: {
    cesiumViewer, 
    cabecera, 
    pie, 
    menuLateral
  },

}
</script>

<style lang="scss" scoped src="./sass/app.scss"></style>




// WEBPACK FOOTER //
// src/App.vue